import { gql, GraphQLClient } from 'graphql-request';
import getConfig from 'next/config';

const hygraphClient = (preview = false) => {
  const { hygraphUrl, hygraphToken, hygraphPreviewToken } =
    getConfig().serverRuntimeConfig;
  const token = (preview && hygraphPreviewToken) || hygraphToken;
  const headers = { Authorization: `Bearer ${token}` };
  if (!hygraphUrl) throw new Error('HYGRAPH_URL is not defined');

  return new GraphQLClient(hygraphUrl, { headers });
};

type GetPageSlugsResponse = {
  pages: {
    id: string;
    slug: string;
    parent: {
      id: string;
    };
  }[];
};

const getPageSlugs = async () =>
  hygraphClient(false).request<GetPageSlugsResponse>(gql`
    query PageSlugsQuery {
      pages {
        id
        slug
        parent {
          id
        }
      }
    }
  `);

export { getPageSlugs, hygraphClient };
